import RatingAndIdentifyDetails from './RatingAndIdentifyDetails'
export default RatingAndIdentifyDetails
